var ECDS = {
    tab1:{
        buildingName:'楼宇名称',
        tenement:'物业单位',
        propertyUnit:'产权单位',
        jiexiang:'所在街乡',
        address:'地址',
        location:'定位',
        park:'所属功能区',
        totalVacantArea:'当前空置可招商面积（平方米）',
        leadingCadre:'招商负责人',
        leadingCadrePhone:'负责人手机号',
        trafficCondition:'周边交通情况',
        supportingSituation:'周边公共配套情况',
        other:'其他补充说明',
        projectType:'项目类型',
        uploadUser:'上传用户',
        createdAt:'创建时间'
    },
    tab2:{
        buildingName:'楼宇名称',
        vacantArea:'空置面积（平方米）',
        controlFloor:'空置楼层',
        jiexiang:'所在街乡',
        decoration:'装修情况',
        decorationInstructions:'装修说明',
        actualUtilization:'实际利用率',
        floorHeight:'层高(米)',
        turnTowards:'朝向',
        paymentMethod:'交付方式',
        price1:'价格（元/天/平方米）',
        propertyCosts:'物业费（元/天/平方米）',
        isSell:'状态',
        sellingInstructions:'出售说明',
        price2:'最高售价',
    },
    tab3:{
        cbName:'出版单位名称',
        xingming:'姓名',
        xingbie:'性别',
        shenfenzheng:'身份证号码',
        zhenzhimmmingcheng:'政治面貌',
        wenhuamingcheng:'文化程度',
        zhuanye1mingcheng:'专业',
        gangweimingcheng:'所在岗位',
        zhiwu:'职务/职称',
        jibiemingcheng:'出版专业职称级别',
        zbzyzyzgzsbh:'出版专业职业资格证书编号',
        zczrbjbh:'注册责任编辑编号',
        yxDate:'注册有效期'
    },
    tab4:{
      iNames:['是否具有辞书出版物资质','是否具有养生保健类出版物出版资质','是否具有地图出版资质','是否具有中小学教辅出版资质'],
      itab1:{
          isZizhi:0,
          nsOrg:'内设机构名称',
          editCount:'编辑总数',
          cbNum1:'2016年出版品种数',
          cbNum2:'2017年出版品种数',
      },
      itab2:{
          xingming:'姓名',
          xuelimingcheng:'学历',
          zhuanye:'专业',
          zhicheng:'职称',
          bumen:'岗位'
      }
    },
    tab5:{
       zyywsr:'主营业务收入（万元）',
       qtywsr:'其他业务收入（万元）',
       pzbzsh:'品种数（标准书号）',
       pztysh:'品种数（统一书号）',
       xsbzsh:'新书品种数（标准书号）',
       xstysh:'新书品种数（统一书号）',
       cypzbzsh:'重印品种数（标准书号）',
       cypztysh:'重印品种数（统一书号）',
       zongyinshu:'总印数（千册）',
       chubanmayang:'定价总金额（万元）',
       fahuomayang:'发货总金额（万元）',
       xiaoshouzongce:'销售总册数（千册）',
       xiaoshoumayang:'销售总金额（万元）',
       xiaoshoushouru:'销售收入（万元）',
       qzszcbsr:'数字出版总额（万元）',
       tushulirun:'图书利润总额（万元）',
       pingjunlirun:'图书单品种平均利润（万元）',
       kucun:'库存（千册）',
       kucunmayang:'库存总金额（万元）'
    },
    tab6:{
       cbName:'出版单位名称',
       year:'年份',
       shuming:'书名',
       biaozhushuhao:'中国标准书号',
       tongyishuhao:'统一书号',
       zhebian:'责编',
       yishen:'初审',
       ershen:'复审',
       sanshen:'终审',
       zishu:'字数（千字）',
       isyinjin:'是否引进版',
       leibiemingcheng:'中国图书分类号',
       iszxxjcmingcheng:'是否中小学教材',
       isjfmingcheng:'是否中小学教辅',
       zaibancymingcheng:'是否再版重印',
       dingjia:'定价(元)',
       yinshu:'印数(册)'
    },
    tab7:{
       hjtime:'时间',
       jiangxiangmingcheng:'表彰奖项',
       hjtushu:'表彰对象（图书或集体名称、个人姓名）',
       banjiangdanwei:'颁奖单位'
    },
    tab8:{
       shuming:'书名',
       xiangmumingcheng:'项目名称',
       zizhujine:'资助金额（万元）',
       wancqk:'完成情况',
       remark:'备注'
    },
    tab9:{
       zhidu:'制度名称',
       zdtime:'发布时间',
       snwenhao:'社内文号',
       zxqk:'执行情况'
    }
};

export default ECDS;



// WEBPACK FOOTER //
// ./src/utils/ECDs.js